import { render, staticRenderFns } from "./ScamAlert.htm?vue&type=template&id=7ea29cfd&scoped=true&"
import script from "./ScamAlert.ts?vue&type=script&lang=js&"
export * from "./ScamAlert.ts?vue&type=script&lang=js&"
import style0 from "./ScamAlert.scss?vue&type=style&index=0&id=7ea29cfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea29cfd",
  null
  
)

export default component.exports